




import CommonBase from "../CommonBase";
import {Component, Prop} from "vue-property-decorator";

@Component
export default class InfoBtn extends CommonBase {
    @Prop({default: false, type: Boolean})
    withoutMargin?: boolean;

    get style() {
        return this.withoutMargin ? { marginTop: 0, marginBottom: 0} : {};
    }
}
